import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { makeStyles } from '@material-ui/styles';
import { Checkbox } from '@material-ui/core';
import AddNewContact from './AddNewContact';
import AddService from './AddService';
import SearchContact from './SearchContact';
import AditionalInfo from '../../../../components/Forms/Perfil/AditionalInfo';
import ProposalDataInfoForm from '../../../../components/Forms/Perfil/ProposalDataInfoForm';
import ProposalDataDetails from '../../../../components/Forms/Perfil/ProposalDataDetails';
import ButtonBase from '../../../../components/Buttons/ButtonBase';
import Snackbar from '../../../../components/Snackbar';
import MainTitle from '../../../../components/MainTitle';
import {
  cleanProposalData,
  loadProposalData,
  setProposalSelected,
} from '../../../../store/actions/ProposalsAction';

import './ProposalData.scss';

const useStyles = makeStyles({
  ButtonBase: {
    margin: '0 24px 0 0',
  },
  checkDetails: {
    position: 'absolute',
    right: 0,
    top: 0,
    padding: 8,
  },
});

const ProposalData = ({
  setStep,
  setCreateView,
  valuesToEdit,
  messageLaw,
  newProposalData,
  cleanProposalData,
  loadProposalData,
  setProposalSelected,

}) => {

  const classes = useStyles();

  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'success',
  });

  // Es el state de SearchContact al momento
  // en modo de edición pon el objeto que corresponda
  // en vez de messageLaw.data[0]
  const [search, setSearch] = useState(
    // messageLaw.data[0] ? messageLaw.data[0] :
    { name: '', email: '' }
  );

  const resetInputs = () => {
    cleanProposalData();
    setCreateView(false);
    window.scroll(0, 0);

  };

  const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
      open: false,
      message: '',
      variant: 'success',
    });
  };

  const validateText = (value) => {
    const regExpStr = "^([A-Za-zäÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙñÑ ]{1,320})$"
    const result = new RegExp(regExpStr) 
    if (result.test(value)) {
      return true;
    } else {
      return false;
    }
  };

  // Valida ProposalDataInfoForm
  const [validationDataInfo, setValidationDataInfo] = useState();
  const setValidationDataInfoWrapper = (action) => {
    if (!validationDataInfo) {
      setValidationDataInfo(() => () => action());
    }
  };
  const runValidationDataInfo = () => {
    validationDataInfo();
  };

  /* Proposal details check */
  const [checked, setChecked] = useState(
    valuesToEdit &&
    valuesToEdit.detailsProposal &&
    valuesToEdit.detailsProposal.check
      ? valuesToEdit.detailsProposal.check
      : true
  );
  /* Proposal details check ends */
  const [contacts, setContacts] = useState([]);
  const [listServices, setListServices] = useState([]);
  const [additionalInfo, setAdditionalInfo] = useState(
    valuesToEdit && valuesToEdit.additionalInformation ? valuesToEdit.additionalInformation :
    newProposalData && newProposalData.additionalInformation ? newProposalData.additionalInformation : ''
  );
  const [detailsProposal, setDetailsProposal] = useState({
    check: true,
    subtotal: '',
    discount: '',
    iva: '',
    checkIva: false,
    total: '',
  });
  const [status, setStatus] =useState('');

  const handleChange = (event) => {
    setChecked(event.target.checked);
    setDetailsProposal({
      ...detailsProposal,
      check: event.target.checked,
      checkIva: !event.target.checked ? false : detailsProposal.checkIva,
    })
  };

  const handleChangeCheckIVA = e => {
    setDetailsProposal({
      ...detailsProposal,
      checkIva: e.target.checked,
    })
  }

  const [ didRender, setDidRender ] = useState(false)

  const calculateProposalDetails = (services) => {
    let subtotalValue = 0
    if (services && services.length !== 0 && checked) {
      subtotalValue = services
        .map(elem => {
          return elem.price;
        })
        .reduce((a, b) => a + b)
    }

    let discountValue = 0
    if (services && services.length !== 0 && checked) {
      discountValue = services
        .map(elem => {
          return elem.discount;
        })
        .reduce((a, b) => {
          return Number(a) + Number(b)
        })
    }
    
    let restValue = 0
    let taxesValue = 0
    if (services && services.length !== 0 && checked) {
      restValue = subtotalValue - discountValue
      if (restValue > 0 && checked && detailsProposal.checkIva) {
        taxesValue = restValue * 0.16
      }
    }
    let parsedTaxesValue = parseFloat(taxesValue).toFixed(2);
    
    let totalValue = 0
    if (services && services.length !== 0 && checked && detailsProposal.checkIva) {
      totalValue = restValue + taxesValue
    } else if (services && services.length !== 0 && checked) {
      totalValue = restValue
    }
    let parsedTotalValue = parseFloat(totalValue).toFixed(2);

    setDetailsProposal({
      ...detailsProposal,
      subtotal: subtotalValue,
      discount: discountValue,
      iva: parsedTaxesValue,
      total: parsedTotalValue,
    })
  }

  useEffect(() => {
    if (!didRender) {
      if (valuesToEdit && Object.values(valuesToEdit).length > 0) {
        valuesToEdit.contact && setContacts(valuesToEdit.contact);
        valuesToEdit.listServices && setListServices(valuesToEdit.listServices);
        valuesToEdit.detailsProposal && setDetailsProposal(valuesToEdit.detailsProposal);
        valuesToEdit.status && setStatus(valuesToEdit.status);
      }
      if (newProposalData && Object.values(newProposalData).length > 0) {
        newProposalData.contact && setContacts(newProposalData.contact);
        newProposalData.listServices && setListServices(newProposalData.listServices);
        newProposalData.detailsProposal &&
          setDetailsProposal(newProposalData.detailsProposal);
        newProposalData.status && setStatus(newProposalData.status);
      }
      setDidRender(true)
    }

    calculateProposalDetails(listServices)

  }, [detailsProposal.checkIva, listServices, checked]);

  const onSubmit = (e) => {
    e.preventDefault();
    // runValidationDataInfo();
    let keepData = (valuesToEdit && Object.values(valuesToEdit).length > 0) ?
      valuesToEdit : newProposalData
    const newData = {
      ...keepData,
      contact: contacts,
      listServices: listServices,
      detailsProposal: detailsProposal,
      additionalInformation: additionalInfo,
      status: status,
      source: 'Contacta Abogado®',
      typeCurrency: 'MXN'
    }
    if (valuesToEdit && Object.values(valuesToEdit).length > 0) {
      setProposalSelected(newData)
    } else {
      loadProposalData(newData);
    }
    window.scroll(0, 0);
    setStep(4);
  };

  console.log('listServices', listServices);

  return (
    <div className="proposalData">
      <div className="proposalData_header">
        <div
          className="proposalData_header_arrowBack"
          onClick={() => setStep(2)}
        >
          <img src="/img/admin/arrow-back.svg" alt="arrow-back" />
          <p>Regresar</p>
        </div>
        <div className="proposalData_header_title">
          <MainTitle
            title="Creación de propuesta económica"
            subtitle="Ingresa la información necesaria para ser lo más específico en las propuestas que enviarás a tus clientes."
          />
        </div>
      </div>
      <div className="proposalData_Main">

        <p className="proposalData_Main-title">
          Información de la propuesta económica
        </p>
        <p className="proposalData_Main-subtitle">
          Esta información es relevante para tu control de propuestas en el
          dashboard.
        </p>
        <ProposalDataInfoForm
          // setValidationAction={setValidationDataInfoWrapper}
        />

        <p className="proposalData_Main-title">Información del contacto</p>
        <p className="proposalData_Main-subtitle">
          Busca o añade al contacto a quien se dirigirá la propuesta económica.
        </p>
        <SearchContact 
          search={search} 
          setSearch={setSearch} 
          contacts={contacts} 
          setContacts={setContacts}
        />
        <AddNewContact contacts={contacts} setContacts={setContacts} />
        <p className="proposalData_Main-title">Lista de servicios</p>
        <p className="proposalData_Main-subtitle">
          Agrega un máximo de 10 servicios que necesites para describir la propuesta económica
        </p>
        <AddService
          listServices={listServices} 
          setListServices={setListServices}
          calculateProposalDetails={calculateProposalDetails}
        />
        <div
          className={`proposalData_Main-${
            checked ? 'details' : 'detailsDisabled'
          }`}
        >
          <p className="proposalData_Main-title">
            Detalles de la propuesta económica
          </p>
          <p className="proposalData_Main-subtitle">
            Es la suma de los costos y descuentos a los servicios agregados.
            Desde aquí puedes agregar el IVA a la propuesta económica.
          </p>
          <Checkbox
            name="add-details"
            id="add-details"
            checked={checked}
            onChange={handleChange}
            value="checked"
            label="Gilad Gray"
            classes={{
              root: classes.checkDetails,
              disabled: classes.checkPaddingDisabled,
            }}
          />
          <ProposalDataDetails
            active={checked}
            detailsProposal={detailsProposal}
            handleChangeCheckIVA={handleChangeCheckIVA}
          />
        </div>
        <p className="proposalData_Main-title">Información adicional</p>
        <p className="proposalData_Main-subtitle">
          Puedes agregar datos adicionales, por ejemplo: Esta propuesta
          económica tiene validez hasta el 14 de Julio de 2020 y está sujeta a
          cambios.
        </p>
        <AditionalInfo
          additionalInfo={additionalInfo}
          setAdditionalInfo={setAdditionalInfo}
        />
        <div className="proposalData_Main-buttonContainer">
          <ButtonBase
            type="submit"
            onClick={onSubmit}
            variant="primary"
            linkStyle={classes.ButtonBase}
            disabled={validateText(additionalInfo) && !contacts.length > 0 || !listServices.length > 0}
          >
            Guardar y continuar
          </ButtonBase>

          <ButtonBase
            type="button"
            onClick={resetInputs}
            variant="primaryOutlined"
            linkStyle={classes.ButtonBase}
          >
            Cancelar
          </ButtonBase>
        </div>
      </div>

      <Snackbar
        open={feedbackMessage.open}
        message={feedbackMessage.message}
        variant={feedbackMessage.variant}
        handleClose={handleCloseFeedbackMessage}
        vertical="top"
        horizontal="right"
        snackbarTop={isMobile ? '70px' : '80px'}
      />
    </div>
  );
};
const mapStateToProps = state => ({

  valuesToEdit: state.proposalsReducer.selectedProposal,
  messageLaw: state.authClient.messageLaw,
  newProposalData: state.proposalsReducer.newProposalData,
});

const mapDispatchToProps = dispatch => ({
  cleanProposalData: () => dispatch(cleanProposalData()),
  loadProposalData: proposalData => dispatch(loadProposalData(proposalData)),
  setProposalSelected: proposalData => dispatch(setProposalSelected(proposalData))
});

export default connect(mapStateToProps, mapDispatchToProps)(ProposalData);

